import CEP from './CEP';

export default CEP;